import { useTranslation } from 'react-i18next';
import { CellType, ICell } from '../../../../base';

export const useTableCells = (): ICell[] => {
    const { t } = useTranslation();

    const cells: Array<ICell> = [
        {
            id: 'id',
            headerTitle: t('dashboardJobsTable.id'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'id' },
        },
        {
            id: 'title',
            headerTitle: t('dashboardJobsTable.jobTitle'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'title' },
        },
        {
            id: 'published_date',
            headerTitle: t('dashboardJobsTable.publishedDate'),
            type: CellType.DateAndTime,
            cellFields: { text: 'publishedDate' },
        },
        {
            id: 'open',
            headerTitle: t('dashboardJobsTable.open'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'openDays' },
        },
        {
            id: 'in_progress_applications',
            headerTitle: t('dashboardJobsTable.inProgressApplications'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'inProgressApplications' },
        },
        {
            id: 'total_applications',
            headerTitle: t('dashboardJobsTable.totalApplications'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'totalApplications' },
        },
    ];
    cells.forEach((cell, index) => {
        cell.columnIndex = index;
    });

    return cells;
};
